/**
* DO NOT EDIT MANUALLY
* This is an auto-generated file.
* Any changes will be overwritten.
*/
import{i as p,r as d,x as r}from"./lit-element-3JpVCGI4.js";import{t as v}from"./custom-element-BhZVzxrc.js";import{r as m}from"./state-BfKPaFon.js";import{c as l,b as f,s as u}from"./events-DEnBj6te.js";import{b as g,h as w,u as _}from"./styles-yPHzqaIp.js";import{g as b,a as y,b as x,r as V}from"./utils-Bgz4qAVt.js";import"./property-B-EZGmlZ.js";import"./client-CV2bJZEs.js";import"./isEqual-DXNOntVp.js";import"./escape-highlight-BQiRaWtq.js";import"./find-DUpcU4oq.js";import"./documentation-BCD0-z0w.js";import"./getInitialAlgoliaUiState-CPHnN7BU.js";import"./config-Dus_iaC-.js";import"./ph-Cp4vR8Iu.js";var k=Object.defineProperty,A=Object.getOwnPropertyDescriptor,h=(e,t,a,c)=>{for(var i=c>1?void 0:c?A(t,a):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(i=(c?n(t,a,i):n(i))||i);return c&&i&&k(t,a,i),i};let s=class extends d{constructor(){super(...arguments),this._showAddVehicleView=()=>{this.dispatchEvent(l)},this.vehicles=b(),this._setActiveVehicle=e=>{e!=y()&&(x(e),window.location.pathname.split("/")[1]=="collections"&&(window.location.href="/search")),this.dispatchEvent(f)},this._removeVehicle=e=>{this.vehicles=V(e)}}render(){return this.vehicles.length==0&&window.location.pathname=="/search"?this.dispatchEvent(l):this.vehicles.length==0&&this.dispatchEvent(u),r`<div class="wrapper">
      <div class="action_bar">
        <h2>My Garage</h2>

        <button class="button__primary" @click="${this._showAddVehicleView}">
          <kanter-icon icon="addCircle"></kanter-icon>
          <span>Add vehicle</span>
        </button>
      </div>

      <div class="content">
        <div class="vehicles">
          ${this.vehicles.map((e,t)=>r`<div
                class="vehicle-entry"
                @click="${()=>{this._setActiveVehicle(e)}}"
              >
                <div class="vehicle__details">
                  <kanter-icon icon="vehicle" filled></kanter-icon>
                  <div>
                    ${e.BegYear} ${e.MakeName} ${e.ModelName}
                    ${e.SubmodelName}
                  </div>
                </div>

                <div class="vehicle-entry__actions">
                  <button
                    class="button__secondary md:sr-only"
                    @click="${()=>{this._setActiveVehicle(e)}}"
                  >
                    Set as vehicle
                  </button>

                  <button
                    class="button__icon"
                    @click="${a=>{a.preventDefault(),a.stopPropagation(),this._removeVehicle(t)}}"
                    title="Remove vehicle"
                  >
                    <kanter-icon icon="crossCircle"></kanter-icon>
                  </button>
                </div>
              </div>`)}
        </div>
      </div>
    </div>`}};s.styles=[g,w,_,p`
      :host {
        width: 100%;
      }

      .wrapper {
        width: 100%;
        display: flex;
        flex-direction: column;
        padding-block-start: calc(8 * var(--space-unit));
      }

      .content {
        display: flex;
        align-items: center;
        flex-direction: row;
        gap: calc(4 * var(--space-unit));
        margin-bottom: calc(4 * var(--space-unit) * -1);
      }

      .vehicles {
        display: flex;
        flex-direction: column;
        width: 100%;
        max-height: 40vh;
        overflow: auto;
      }

      .vehicle-entry {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        border-top: 1px solid rgb(var(--text-color-og) / 0.2);
        flex-wrap: nowrap;
        padding: calc(8 * var(--space-unit)) calc(2 * var(--space-unit));
        transition: background-color 0.2s ease-in-out;
        gap: calc(4 * var(--space-unit));
        font-size: calc(var(--h6-font-size));
        font-family: var(--navigation-font-family);
        font-style: var(--navigation-font-style);
        font-weight: var(--navigation-font-weight);
        line-height: 1;

        @media (min-width: 1024px) {
          gap: calc(8 * var(--space-unit));
        }

        &:hover {
          cursor: pointer;
          background-color: #e01a1a;
        }

        &:first-child {
          margin-top: calc(8 * var(--space-unit));
        }

        .vehicle-entry__actions {
          display: flex;
          align-items: center;
          gap: calc(2 * var(--space-unit));
          flex-direction: column;

          @media (min-width: 1024px) {
            flex-direction: row;
          }
        }
      }

      .vehicle__details {
        display: flex;
        align-items: center;
        gap: calc(4 * var(--space-unit));
      }
    `];h([m()],s.prototype,"vehicles",2);s=h([v("kanter-garage-filled")],s);
